// extracted by mini-css-extract-plugin
module.exports = {"title":"CollectionTitle-module--title--CgDP0","subtitle":"CollectionTitle-module--subtitle--h0lHM"};